export interface WithUpdatedAt {
  updatedAt: number;
}

export function byLastModified(one: WithUpdatedAt, other: WithUpdatedAt) {
  return other.updatedAt - one.updatedAt;
}
